import { createReducer, on } from '@ngrx/store';
import * as CompanyManagementActions from './company-management.actions';

export const initialState: CompanyManagementActions.CompanyManagementState = {
  companyUser: { loading: false, data: null, error: null },
  companyStaffs: { loading: false, data: null, error: null },
  globalRoles: { loading: false, data: null, error: null },
  viewCompanyUser: { loading: false, data: null, error: null },
  toggleCompanyUserStatus: { loading: false, data: null, error: null },
  viewGlobalRole: { loading: false, data: null, error: null },
  deleteCompanyUser: { loading: false, data: null, error: null },
  designations: { loading: false, data: null, error: null },
  companyRegistrationLetters: { loading: false, data: null, error: null },
  viewCompanyLetter: { loading: false, data: null, error: null },
  resendInviteLink: { loading: false, data: null, error: null },
};

export const companyManagementReducer = createReducer(
  initialState,

  /* ---------- companyManagement  ---------- */
  on(CompanyManagementActions.companyUserRequest, (state) => ({
    ...state,
    companyUser: {
      ...state.companyUser,
      loading: true,
      data: null,
      error: null,
    },
  })),

  on(CompanyManagementActions.companyUserSuccess, (state, { response }) => ({
    ...state,
    companyUser: {
      ...state.companyUser,
      loading: false,
      data: response.data,
      error: null,
    },
  })),

  on(CompanyManagementActions.companyUserFailed, (state, { error }) => ({
    ...state,
    companyUser: {
      ...state.companyUser,
      loading: false,
      data: null,
      error: error,
    },
  })),

  /* ---------- COMPANY STAFFS  ---------- */
  on(CompanyManagementActions.companyStaffsRequest, (state) => ({
    ...state,
    companyStaffs: {
      ...state.companyStaffs,
      loading: true,
      data: null,
      error: null,
    },
  })),

  on(CompanyManagementActions.companyStaffsSuccess, (state, { response }) => ({
    ...state,
    companyStaffs: {
      ...state.companyStaffs,
      loading: false,
      data: response,
      error: null,
    },
  })),

  on(CompanyManagementActions.companyStaffsFailed, (state, { error }) => ({
    ...state,
    companyStaffs: {
      ...state.companyStaffs,
      loading: false,
      data: null,
      error: error,
    },
  })),

  /* ----------  GLOBAL ROLES  ---------- */
  on(CompanyManagementActions.globalRolesRequest, (state) => ({
    ...state,
    globalRoles: {
      ...state.globalRoles,
      loading: true,
      data: null,
      error: null,
    },
  })),

  on(CompanyManagementActions.globalRolesSuccess, (state, { response }) => ({
    ...state,
    globalRoles: {
      ...state.globalRoles,
      loading: false,
      data: response,
      error: null,
    },
  })),

  on(CompanyManagementActions.globalRolesFailed, (state, { error }) => ({
    ...state,
    globalRoles: {
      ...state.globalRoles,
      loading: false,
      data: null,
      error: error,
    },
  })),

  /* ----------  VIEW COMPANY USER  ---------- */
  on(CompanyManagementActions.viewCompanyUserRequest, (state) => ({
    ...state,
    viewCompanyUser: {
      ...state.viewCompanyUser,
      loading: true,
      data: null,
      error: null,
    },
  })),

  on(CompanyManagementActions.viewCompanyUserSuccess, (state, { response }) => ({
    ...state,
    viewCompanyUser: {
      ...state.viewCompanyUser,
      loading: false,
      data: response,
      error: null,
    },
  })),

  on(CompanyManagementActions.viewCompanyUserFailed, (state, { error }) => ({
    ...state,
    viewCompanyUser: {
      ...state.viewCompanyUser,
      loading: false,
      data: null,
      error: error,
    },
  })),

  /* ----------  TOGGLE COMPANY USER STATUS  ---------- */
  on(CompanyManagementActions.toggleCompanyUserStatusRequest, (state) => ({
    ...state,
    toggleCompanyUserStatus: {
      ...state.toggleCompanyUserStatus,
      loading: true,
      data: null,
      error: null,
    },
  })),

  on(CompanyManagementActions.toggleCompanyUserStatusSuccess, (state, { response }) => ({
    ...state,
    toggleCompanyUserStatus: {
      ...state.toggleCompanyUserStatus,
      loading: false,
      data: response,
      error: null,
    },
  })),

  on(CompanyManagementActions.toggleCompanyUserStatusFailed, (state, { error }) => ({
    ...state,
    toggleCompanyUserStatus: {
      ...state.toggleCompanyUserStatus,
      loading: false,
      data: null,
      error: error,
    },
  })),

  on(CompanyManagementActions.clearToggleCompanyUsersStatus, (state) => ({
    ...state,
    toggleCompanyUserStatus: null,
  })),

  /* ----------  VIEW GLOBAL ROLE ---------- */
  on(CompanyManagementActions.viewGlobalRoleRequest, (state) => ({
    ...state,
    viewGlobalRole: {
      ...state.viewGlobalRole,
      loading: true,
      data: null,
      error: null,
    },
  })),

  on(CompanyManagementActions.viewGlobalRoleSuccess, (state, { response }) => ({
    ...state,
    viewGlobalRole: {
      ...state.viewGlobalRole,
      loading: false,
      data: response,
      error: null,
    },
  })),

  on(CompanyManagementActions.viewGlobalRoleFailed, (state, { error }) => ({
    ...state,
    viewGlobalRole: {
      ...state.viewGlobalRole,
      loading: false,
      data: null,
      error: error,
    },
  })),

  on(CompanyManagementActions.clearViewGlobalRole, (state) => ({
    ...state,
    viewGlobalRole: null,
  })),

  /* ----------  DELETE COMPANY USER ---------- */
  on(CompanyManagementActions.deleteCompanyUserRequest, (state) => ({
    ...state,
    deleteCompanyUser: {
      ...state.deleteCompanyUser,
      loading: true,
      data: null,
      error: null,
    },
  })),

  on(CompanyManagementActions.deleteCompanyUserSuccess, (state, { response }) => ({
    ...state,
    deleteCompanyUser: {
      ...state.deleteCompanyUser,
      loading: false,
      data: response,
      error: null,
    },
  })),

  on(CompanyManagementActions.deleteCompanyUserFailed, (state, { error }) => ({
    ...state,
    deleteCompanyUser: {
      ...state.deleteCompanyUser,
      loading: false,
      data: null,
      error: error,
    },
  })),

  /* ----------  DESIGNATIONS ---------- */
  on(CompanyManagementActions.listDesignationsRequest, (state) => ({
    ...state,
    designations: { ...state.designations, loading: true, data: null, error: null },
  })),

  on(CompanyManagementActions.listDesignationsSuccess, (state, { response }) => ({
    ...state,
    designations: { ...state.designations, loading: false, data: response, error: null },
  })),

  on(CompanyManagementActions.listDesignationsFailed, (state, { error }) => ({
    ...state,
    designations: { ...state.designations, loading: false, data: null, error: error },
  })),

  /* ---------- Company Letters ---------- */
  on(CompanyManagementActions.companyRegistrationLettersRequest, (state) => ({
    ...state,
    companyRegistrationLetters: {
      ...state.companyRegistrationLetters,
      loading: true,
      data: null,
      error: null,
    },
  })),

  on(CompanyManagementActions.companyRegistrationLettersSuccess, (state, { response }) => ({
    ...state,
    companyRegistrationLetters: {
      ...state.companyRegistrationLetters,
      loading: false,
      data: response,
      error: null,
    },
  })),

  on(CompanyManagementActions.companyRegistrationLettersFailed, (state, { error }) => ({
    ...state,
    companyRegistrationLetters: {
      ...state.companyRegistrationLetters,
      loading: false,
      data: null,
      error: error,
    },
  })),

  on(CompanyManagementActions.clearCompanyRegistrationLetters, (state) => ({
    ...state,
    companyRegistrationLetters: {
      loading: false,
      data: null,
      error: null,
    },
  })),

  on(CompanyManagementActions.viewCompanyLetterRequest, (state) => ({
    ...state,
    viewCompanyLetter: {
      ...state.viewCompanyLetter,
      loading: true,
      data: null,
      error: null,
    },
  })),

  on(CompanyManagementActions.viewCompanyLetterSuccess, (state, { response }) => ({
    ...state,
    viewCompanyLetter: {
      ...state.viewCompanyLetter,
      loading: false,
      data: response,
      error: null,
    },
  })),

  on(CompanyManagementActions.viewCompanyLetterFailed, (state, { error }) => ({
    ...state,
    viewCompanyLetter: {
      ...state.viewCompanyLetter,
      loading: false,
      data: null,
      error: error,
    },
  })),

  on(CompanyManagementActions.clearViewCompanyLetter, (state) => ({
    ...state,
    viewCompanyLetter: {
      loading: false,
      data: null,
      error: null,
    },
  })),

  /* ---------- RESEND INVITE LINK ---------- */
  on(CompanyManagementActions.resendInviteLinkRequest, (state) => ({
    ...state,
    resendInviteLink: {
      ...state.resendInviteLink,
      loading: true,
      data: null,
      error: null,
    },
  })),

  on(CompanyManagementActions.resendInviteLinkSuccess, (state, { response }) => ({
    ...state,
    resendInviteLink: {
      ...state.resendInviteLink,
      loading: false,
      data: response,
      error: null,
    },
  })),

  on(CompanyManagementActions.resendInviteLinkFailed, (state, { error }) => ({
    ...state,
    resendInviteLink: {
      ...state.resendInviteLink,
      loading: false,
      data: null,
      error: error,
    },
  })),

  on(CompanyManagementActions.clearResendInviteLinkState, (state) => ({
    ...state,
    resendInviteLink: {
      loading: false,
      data: null,
      error: null,
    },
  }))
);
